module.exports = __webpack_public_path__ + "img/21.d91ee31f.png";